<template>
  <div
    id="app"
    v-bind:class="{ fullBody: isFullBody, smallerNavbar: smallerNavbar }"
  >
    <BootstrapSizeChecker @bs-size-changed="bsSizeChanged" />
    <Navbar
      v-if="showNavbar"
      v-bind:items="navbarItems"
      brandRoute="/dashboard"
    />

    <router-view
      v-on:navbar-items="updateNavbarItems"
      v-on:toggle-navbar="toggleNavbar"
      v-on:full-body="toggleFullBody"
    >
      <template v-slot:footer>
        <Footer />
      </template>
    </router-view>

    <DialogError v-model="errorVisible" @hidden="errorDismissed">
      {{ errorMessage }}
    </DialogError>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar";
import DialogError from "@/components/DialogError";
import BootstrapSizeChecker from "@/components/utils/BootstrapSizeChecker";

export default {
  name: "app",
  components: {
    Footer,
    Navbar,
    DialogError,
    BootstrapSizeChecker
  },
  computed: {
    smallerNavbar() {
      return ["xs", "sm", "md"].includes(this.$store.state.bootstrapScreenSize);
    }
  },
  data() {
    return {
      showNavbar: true,
      isFullBody: false,
      errorVisible: false,
      errorMessage: "",
      goHomeOnErrorDismiss: false,
      navbarItems: [
        {
          id: 1,
          item: { name: "Home", to: "/dashboard", requiresLogin: true }
        },
        {
          id: 2,
          item: {
            name: "Host area",
            to: "/host",
            requiredRole: this.$tqConstants["USER_ROLE_HOST"]
          }
        },
        {
          id: 3,
          item: {
            name: "Admin area",
            to: "/admin",
            requiredRole: this.$tqConstants["USER_ROLE_ADMIN"]
          }
        },
        { id: 4, item: { name: "About", to: "/about" } }
      ]
    };
  },
  created() {
    this.$topquiz.checkSession(
      () => {},
      () => {
        if (!this.$route.meta.noAuth) {
          this.$router.push("/");
        }
      }
    );

    this.$topquiz.on(
      this,
      "session_success",
      params => {
        this.$store.dispatch("login", params);
      },
      true
    );
    this.$topquiz.on(
      this,
      "accountDeleted",
      params => {
        var reason = params[0];
        this.goHomeOnErrorDismiss = true;
        this.errorMessage =
          "Your account has been deleted for the following reason: " + reason;
        this.errorVisible = true;
      },
      true
    );

    this.$topquiz.on(this, "quizMeta", params => {
      var quizID = params[0];
      var viewerCount = params[1];
      var viewerInfo = { quizID, viewerCount };

      this.$store.commit("setViewerInfo", viewerInfo);
    });

    this.$topquiz.on(this, "frontEndVersion_success", params => {
      var version = params[0];
      if (!version) {
        return;
      }

      var reloadAllowed = true;
      var lastReload = localStorage.getItem("versionReload_last");
      if (lastReload) {
        var minutesSinceLastReload = this.$moment().diff(
          this.$moment(parseInt(lastReload)),
          "minutes"
        );
        reloadAllowed = minutesSinceLastReload > 5;
      }

      this.$store.dispatch("setFrontEndVersion", version);

      var currentVersion = this.getVersionNumber(version);
      var browserVersion = this.getVersionNumber(this.$settings.version);

      if (browserVersion < currentVersion) {
        if (reloadAllowed) {
          localStorage.setItem("versionReload_last", this.$moment().valueOf());
          location.reload(true);
        }
      }
    });

    this.$topquiz.connect(false);
    this.$topquiz.sendCommand("frontEndVersion");
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    updateNavbarItems: function(items) {
      this.navbarItems = items;
    },
    toggleNavbar: function(showNavbar) {
      this.showNavbar = showNavbar;
    },
    toggleFullBody: function(full) {
      this.isFullBody = full;
    },
    bsSizeChanged(bsSize) {
      this.$store.commit("setBootstrapSize", bsSize);
    },
    errorDismissed() {
      if (this.goHomeOnErrorDismiss) {
        this.$router.push("/");
      }
    },
    getVersionNumber(input) {
      var output = "";
      for (let i = 0; i < input.length; i++) {
        var c = input.charAt(i);
        if (c >= "0" && c <= "9") {
          output += c;
        }
        if (c == "." && !output.includes(".")) {
          output += c;
        }
      }
      return parseFloat(output);
    }
  },
  watch: {
    $route() {
      this.isFullBody = false;
      this.showNavbar = true;
    }
  }
};
</script>

<style scoped>
.smallerNavbar {
  padding-top: 65px !important;
}
</style>
